import { PACKAGE_LEVEL, PACKAGE_TYPE } from '@src/constants/package';
import React from 'react';
import { LANGUAGE } from '@src/constants';
import Tooltip from '@src/components/Tooltip';
import GiftIcon from '@src/assets/icons/gift-filled-icon.svg';
import LogoPackVip from '@src/assets/logo/logo-pack-vip.svg';
import { Typography } from '@mui/material';
import classNames from 'classnames';
import sanitizeHtml from 'sanitize-html';
import i18n from '@src/languages';
import { useTranslation } from 'react-i18next';

import { checkVietNam } from '@src/utils/checkCountry';
import InfoVoucher from '../InfoVoucher';

const PackageHeader = ({
  pkg,
  isDiscountPackage,
  bestVoucher,
  isApplyFirstPaidVoucher,
}) => {
  const { t } = useTranslation();
  const { language } = i18n;
  const isVietNam = checkVietNam();

  return (
    <>
      <div className="package-header">
        <div className="name-content">
          {pkg?.level === PACKAGE_LEVEL.VIP && (
            <img src={LogoPackVip} className="crown-icon" alt="crown-icon" />
          )}
          {pkg?.level !== PACKAGE_LEVEL.VIP && (
            <Typography
              className={classNames('package-name', {
                'package-name-popular': isDiscountPackage || pkg.mostPopular,
                'package-name-vip': pkg?.level === PACKAGE_LEVEL.VIP,
              })}
            >
              {pkg.name && (pkg.name[language] || pkg.name[LANGUAGE.EN])}
            </Typography>
          )}
        </div>
        {bestVoucher && !isApplyFirstPaidVoucher && (
          <Tooltip arrow placement="top" title={t('bestVoucherApplied')}>
            <div className="voucher-gift-icon">
              <img src={GiftIcon} alt="voucher-icon" />
              <InfoVoucher
                bestVoucher={bestVoucher}
                isVietNam={isVietNam}
                language={language}
              />
            </div>
          </Tooltip>
        )}
      </div>
      {pkg?.type !== PACKAGE_TYPE.API && (
        <Typography
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(
              language === LANGUAGE.VN
                ? pkg?.description?.[language]
                : pkg?.description?.[LANGUAGE.EN],
            ),
          }}
          className="description-package"
        />
      )}
    </>
  );
};

export default PackageHeader;
